// skipcq: JS-W1028
import FilterListIcon from '@mui/icons-material/FilterList';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

import { PORTFOLIO_SORT_OPTIONS } from '../../utils/brewhousePortfolio/portfolioBeerSort';
import { PORTFOLIO_STYLE_FILTER_ALL } from '../../utils/brewhousePortfolio/portfolioStyleFilters';
import PrimaryActionButton from '../common/PrimaryActionButton';
import PintPortfolioFilterSortSheet from './PintPortfolioFilterSortSheet';

function PintPortfolioRibbon({
  searchQuery,
  onSearchChange,
  sortMode,
  onSortChange,
  styleCategory,
  onStyleCategoryChange,
  styleCategories,
  styleName,
  onStyleNameChange,
  styleNames,
  filterSheetOpen,
  onFilterSheetOpen,
  onFilterSheetClose,
  onAddBeerClick,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const filterControls = (
    <>
      <FormControl size="small" sx={{ minWidth: 160, m: 0.5 }}>
        <InputLabel id="pint-portfolio-sort-label">Sort</InputLabel>
        <Select
          labelId="pint-portfolio-sort-label"
          value={sortMode}
          label="Sort"
          onChange={onSortChange}
        >
          {PORTFOLIO_SORT_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 180, m: 0.5 }}>
        <InputLabel id="pint-portfolio-category-label">Style Category</InputLabel>
        <Select
          labelId="pint-portfolio-category-label"
          value={styleCategory}
          label="Style Category"
          onChange={onStyleCategoryChange}
        >
          <MenuItem value={PORTFOLIO_STYLE_FILTER_ALL}>All categories</MenuItem>
          {styleCategories.map((category) => (
            <MenuItem key={category} value={category}>
              {category}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 180, m: 0.5 }}>
        <InputLabel id="pint-portfolio-style-name-label">Style Name</InputLabel>
        <Select
          labelId="pint-portfolio-style-name-label"
          value={styleName}
          label="Style Name"
          onChange={onStyleNameChange}
        >
          <MenuItem value={PORTFOLIO_STYLE_FILTER_ALL}>All styles</MenuItem>
          {styleNames.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (muiTheme) => muiTheme.zIndex.appBar - 1,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        py: 1,
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <TextField
          size="small"
          placeholder="Search beers"
          value={searchQuery}
          onChange={onSearchChange}
          sx={{ flexGrow: 1, minWidth: isMobile ? '100%' : 220, m: 0.5 }}
          inputProps={{ 'aria-label': 'Search beers' }}
        />

        {isMobile ? (
          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            onClick={onFilterSheetOpen}
            sx={{ m: 0.5 }}
          >
            Filter &amp; sort
          </Button>
        ) : (
          <>
            {filterControls}
            <PrimaryActionButton
              onClick={onAddBeerClick}
              sx={{ m: 0.5, ml: 'auto' }}
            >
              Add beer
            </PrimaryActionButton>
          </>
        )}
      </Box>

      {isMobile && onAddBeerClick ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 1,
          }}
        >
          <PrimaryActionButton onClick={onAddBeerClick} sx={{ m: 0.5 }}>
            Add beer
          </PrimaryActionButton>
        </Box>
      ) : null}

      {isMobile ? (
        <PintPortfolioFilterSortSheet
          open={filterSheetOpen}
          onClose={onFilterSheetClose}
          onOpen={onFilterSheetOpen}
          sortMode={sortMode}
          onSortChange={onSortChange}
          styleCategory={styleCategory}
          onStyleCategoryChange={onStyleCategoryChange}
          styleCategories={styleCategories}
          styleName={styleName}
          onStyleNameChange={onStyleNameChange}
          styleNames={styleNames}
        />
      ) : null}
    </Box>
  );
}

PintPortfolioRibbon.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  sortMode: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  styleCategory: PropTypes.string.isRequired,
  onStyleCategoryChange: PropTypes.func.isRequired,
  styleCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  styleName: PropTypes.string.isRequired,
  onStyleNameChange: PropTypes.func.isRequired,
  styleNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  filterSheetOpen: PropTypes.bool.isRequired,
  onFilterSheetOpen: PropTypes.func.isRequired,
  onFilterSheetClose: PropTypes.func.isRequired,
  onAddBeerClick: PropTypes.func,
};

PintPortfolioRibbon.defaultProps = {
  onAddBeerClick: null,
};

export default PintPortfolioRibbon;
